/** Frontend mirror of backend ADMIN_ROUTE_PERMISSIONS. */
export const ADMIN_ROUTE_PERMISSIONS: Record<string, string> = {
  '/admin': 'dashboard.view',
  '/admin/users': 'users.view',
  '/admin/kyc': 'identity.view',
  '/admin/roles': 'roles.view',
  '/admin/businesses': 'businesses.view',
  '/admin/marketplace': 'marketplace.view',
  '/admin/orders': 'orders.view',
  '/admin/cj-products': 'products.view',
  '/admin/payouts': 'finance.view',
  '/admin/payment-activity': 'payments.view',
  '/admin/finance-dashboard': 'finance.view',
  '/admin/finance-ledger': 'finance.view',
  '/admin/finance-reconciliation': 'finance.view',
  '/admin/finance-booking-payouts': 'finance.approve',
  '/admin/finance-charges': 'finance.configure',
  '/admin/subscriptions': 'subscriptions.view',
  '/admin/content': 'content.view',
  '/admin/cms': 'cms.view',
  '/admin/categories': 'categories.view',
  '/admin/moderation': 'moderation.view',
  '/admin/disputes': 'disputes.view',
  '/admin/verification-queue': 'verification.view',
  '/admin/analytics': 'analytics.view',
  '/admin/ads': 'ads.view',
  '/admin/rewards': 'rewards.view',
  '/admin/referrals': 'referrals.view',
  '/admin/creator-rewards': 'creator_rewards.view',
  '/admin/live-center': 'live.view',
  '/admin/calendar': 'calendar.view',
  '/admin/logs': 'logs.view',
  '/admin/feature-flags': 'feature_flags.view',
  '/admin/app-settings': 'settings.view',
  '/admin/ai-infrastructure': 'ai.view',
  '/admin/plans-pricing': 'subscriptions.view',
  '/admin/billing-webhooks': 'finance.view',
  '/admin/rental-agreements': 'finance.view',
};

export function permissionForPath(path: string): string | undefined {
  const normalized = path.replace(/\/$/, '') || '/';
  if (ADMIN_ROUTE_PERMISSIONS[normalized]) return ADMIN_ROUTE_PERMISSIONS[normalized];
  const match = Object.keys(ADMIN_ROUTE_PERMISSIONS)
    .filter((p) => p !== '/admin' && normalized.startsWith(p))
    .sort((a, b) => b.length - a.length)[0];
  return match ? ADMIN_ROUTE_PERMISSIONS[match] : undefined;
}
